import React, { useEffect } from 'react';
import { SidebarPageLayout } from '@layout/SidebarPageLayout';
import { PageProps } from '@model/pages';
import { ERROR_CODES } from '@model/common/error-codes';
import { TripTypes, Destination } from '@model/common';
import { PageConfig } from '@model/content';
import { useDispatch } from 'react-redux';
import { Error404 } from '@components/common/hero/error/Error404';
import { setTripTypeFilter } from '@state/slices/navigation';

/* ***************** *
 *       Types       *
 * ***************** */
export interface TravelGuidePageLayoutProps extends PageProps {
  pageConfig: PageConfig;
  destination: Destination;
  path: string;
  tripType?: TripTypes;
}

export const TravelGuidePageLayout = ({
  pageConfig,
  destination,
  path,
  tripType,
  promoBannerTripType
}: TravelGuidePageLayoutProps) => {
  if (!pageConfig) return <Error404 code={ERROR_CODES.NO_TRAVEL_GUIDE} />;

  const { components } = pageConfig;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTripTypeFilter(tripType || TripTypes.ALL));
  }, []);

  return (
    <SidebarPageLayout
      components={components}
      tripType={tripType}
      path={path}
      destination={destination}
      promoBannerTripType={promoBannerTripType}
    />
  );
};
